import { useTranslation } from "react-i18next";
import EmployeeWeekCard from "../../../test/EmployeeWeekCard";


export default function WorkerContractDetail(
    {
        contractDetail
    }
) {

    const [t] = useTranslation(["global"])

    function getColor(value) {
        if (value > 0) {
            return "text-accent"
        } else return "text-danger"

    }

    function reverseDate(date) {
        if (date != null)
            return date.split("-").reverse().join("-")
    }

    return (

        <>

            <div className="card bg-dark mb-4">
                <div className="card-header text-muted">{t("absenceReport:menu.work_contract")}</div>
                <div className="card-body">
                    <div className="row text-center mb-4">
                        <div className="col ">
                            <p className="text-muted">{t("absenceReport:property.contractual_level")}</p>
                            <h4><i className="fa-solid fa-briefcase text-eh"></i> {contractDetail.workerClass.name}</h4>

                        </div>
                        <div className="col">
                        <p className="text-muted">{t("absenceReport:property.weekly_hours")}</p>
                            <h4><i className="fa-regular fa-clock text-eh"></i> <b>{contractDetail.weeklyHours}</b> </h4>
                        </div>
                        <div className="col">
                        <p className="text-muted">{t("absenceReport:property.employment_date")}</p>
                            <h4><b >{reverseDate(contractDetail.employmentDate)}</b></h4>
                        </div>
                    </div>

                    <div className="row text-center px-4">
                        <EmployeeWeekCard week={contractDetail.week}/>
                    </div>


                </div>

            </div>
        </>

    )

}